import {
    createTimeStreamAsset,
    getSelectedProjectId,
    snapToGrid,
    ActionSource,
} from 'owa-timestream-store';
import type { NewAsset } from 'owa-timestream-asset-sdk-types';
import pageToDocumentCoordinates from './pageToDocumentCoordinates';

export default function createAssetOnPageCoordinates<T>(
    pageX: number,
    pageY: number,
    asset: NewAsset<T>,
    source: ActionSource
) {
    const { x, y } = pageToDocumentCoordinates(pageX, pageY);

    const newAsset = {
        ...asset,
        x: snapToGrid(x),
        y: snapToGrid(y),
    };

    createTimeStreamAsset(getSelectedProjectId(), newAsset, source);
}
